var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:['card-item-container', { 'app-border-bottom': _vm.printBorder }],attrs:{"tile":"","flat":""}},[_c('div',{staticClass:"image-container"},[_vm._t("image")],2),_c('div',{staticClass:"item-container"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }